<template>
  <transition mode="out-in" name="slide-left">
    <div class="service-select-box dx-flex" v-show="show">
      <i class="far fa-times-circle" @click="close"></i>
      <div>
        <div class="ss-location d-flex align-start">
          <div class="ss-l-icon">
            <i class="fas fa-walking"></i>
            <i class="fas fa-car-side"></i>
          </div>
          <div class="ss-loc-txt">{{ pickup }}</div>
          <i class="fas fa-long-arrow-alt-right"></i>
          <div class="ss-loc-txt">{{ dropoff }}</div>
        </div>
        <div class="ss-pickuptime">Pickup time: {{ pickupTime }}</div>

        <div class="service-details">
          <div v-for="(catgry, x) in category" :key="x" class="sd-category">
            <div class="sd-c-label">{{ x }}</div>
            <div class="sd-c-services">
              <div :class="['sd-c-box d-flex flex-column justify-space-between', {'more-info': hideInfo.indexOf(service.id) === -1 && !isLyft, 'sd-active':selectedID === service.id, 'is-lyft':isLyft}]" v-for="(service, i) in catgry" :key="i">
                <div>
                  <div class="sd-c-price" v-if="currency.code === 'USD'">{{ priceFormat(fullPrice(service), true) }}</div>
                  <div class="sd-c-price" v-else>{{ applyCurrency(fullPrice(service)) }}</div>
                  <img :src="service.img" />
                  <div class="sd-c-name">{{ cabinLabel(service.name) }}</div>
                  <div class="sd-c-capacity d-flex">
                    <div>
                      <i class="far fa-user"></i>
                      {{ service.maxPax }}
                    </div>
                    <div>
                      <i class="fas fa-suitcase"></i>
                      {{ service.maxLuggage }}
                    </div>
                  </div>

                  <div class="more-info-cta" @click="toggleInfo(service.id)" v-show="hideInfo.indexOf(service.id) > -1">More Info</div>
                  <transition name="slide-down" mode="out-in">
                    <div class="more-info-box" v-show="hideInfo.indexOf(service.id) === -1">
                      <span>{{ service.desc }}</span>
                      <div v-if="service.advantage" class="mi-adv">
                        <b>Advantage</b>
                        <span>{{ service.advantage  }}</span>
                      </div>
                      <div class="more-info-cta" @click="toggleInfo(service.id)">Hide Info</div>
                    </div>
                  </transition>
                </div>

                <div :class="['lr-btn', {active:selectedID === service.id}]" :disabled="selectedID === service.id" @click="select(service.id)">
                  <span v-if="selectedID === service.id">Selected</span>
                  <span v-else>Select</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import moment from 'moment-timezone'
import xcurrency from '@/modules/api/currency'

export default {
  name: 'service-select',
  props: ['show', 'extraData'],
  data () {
    return {
      pickup: '',
      dropoff: '',
      pickupTime: '',
      category: [],
      selectedID: '',
      hideInfo: []
    }
  },
  computed: {
    booking () { return this.$store.state.booking },
    locations () { return this.booking.locations },
    selected () { return this.booking.selected },
    landQuote () { return this.booking.landQuote },
    other () { return this.$store.state.other },
    currency () { return this.other.currency },
    isLyft () {
      let type = `${this.extraData.leg}${this.extraData.type === 'pickup' ? 'Depart' : 'Arrive'}`
      return this.booking.landQuoteType[type] === 'lyft'
    }
  },
  methods: {
    timeFormat (x) {
      if (!x) return ''
      return moment(x, 'MM/DD/YYYY hh:mmA').format('h:mma')
    },
    fullPrice (service) {
      let landFee = service.price
      landFee += service.tip + service.pickupFee + service.airportFee + service.gasFee + service.travelInsurance
      if (parseFloat(landFee) < 0) landFee = 0
      return landFee
    },
    priceFormat (data, addSymbol = false) {
      let val = parseFloat(data).toLocaleString('en-US', {minimumFractionDigits: 2})
      if (addSymbol) {
        return data < 0 ? `-$ ${Math.abs(val).toFixed(2)}` : `$ ${val}`
      }
      return val
    },
    applyCurrency (x, useSymbol = true) {
      x = parseFloat(x)
      x = x * this.currency.value
      if (!useSymbol) {
        return parseFloat(x.toFixed(2))
      }
      return xcurrency.format({
        code: this.currency.code,
        val: x.toFixed(2)
      }, useSymbol)
    },
    toggleInfo (x) {
      let index = this.hideInfo.indexOf(x)
      if (index === -1) this.hideInfo.push(x)
      else this.hideInfo.splice(index, 1)
    },
    select (id) {
      let tmpGround = {}
      // tmpGround[this.extraData.type === 'pickup' ? 'ground1' : 'ground2'] = id
      tmpGround[this.extraData.type] = id
      this.$store.commit('booking/updateSelectedGroundData', {
        leg: this.extraData.leg,
        fields: tmpGround
      })
      this.close()
    },
    close () {
      this.$emit('close')
    },
    cabinLabel (x) {
      if (x === 'PremiumEconomy') return 'Premium Economy'
      return x
    }
  },
  watch: {
    'show': function (val) {
      if (val) {
        if (this.extraData.leg === 'leg1') {
          if (this.extraData.type === 'pickup') {
            this.pickup = this.locations.pickup.title
            this.dropoff = `${this.locations.pickupAirport.name} (${this.locations.pickupAirport.code})`
            this.pickupTime = this.timeFormat(this.locations.pickupDetails.pickupTime.leg1)
            this.category = this.landQuote.leg1Depart.categorized
          } else {
            this.pickup = `${this.locations.dropoffAirport.name} (${this.locations.dropoffAirport.code})`
            this.dropoff = this.locations.dropoff.title
            this.pickupTime = this.timeFormat(this.locations.dropoffDetails.pickupTime.leg1)
            this.category = this.landQuote.leg1Arrive.categorized
          }
        }
        if (this.extraData.leg === 'leg2') {
          if (this.extraData.type === 'pickup') {
            this.pickup = this.locations.dropoff.title
            this.dropoff = `${this.locations.dropoffAirport.name} (${this.locations.dropoffAirport.code})`
            this.pickupTime = this.timeFormat(this.locations.pickupDetails.pickupTime.leg2)
            this.category = this.landQuote.leg2Depart.categorized
          } else {
            this.pickup = `${this.locations.pickupAirport.name} (${this.locations.pickupAirport.code})`
            this.dropoff = this.locations.pickup.title
            this.pickupTime = this.timeFormat(this.locations.dropoffDetails.pickupTime.leg2)
            this.category = this.landQuote.leg2Arrive.categorized
          }
        }
        // this.selectedID = this.selected[this.extraData.leg][this.extraData.type === 'pickup' ? 'ground1' : 'ground2']
        this.selectedID = this.booking.selectedGround[this.extraData.leg][this.extraData.type]
        this.hideInfo = []
        document.body.classList.add('widget-no-scroll')
      } else {
        setTimeout(() => {
          document.body.classList.remove('widget-no-scroll')
        }, 300)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.service-select-box{
  height: 100vh;
  width: 600px;
  position: fixed;
  top: 0;
  right: 0;
  z-index: 3;
  padding: 25px 15px;
  overflow: auto;
  gap: 15px;
  background: #fff;
  box-shadow: 0 2px 10px 3px rgba(0,0,0,.3);

  .fa-times-circle,
  .ss-l-icon{
    color: #717b87;
  }
  .fa-times-circle{
    font-size: 24px;
    cursor: pointer;
  }
  .ss-l-icon{
    font-size: 21px;
    align-self: start;
  }
  .ss-location{
    gap: 10px;
    margin-bottom: 10px;
  }
  .ss-loc-txt{
    font-weight: 600;
    font-size: 18px;
    line-height: 1.3;
    letter-spacing: .5px;
    width: calc(50% - 45px);
  }
  .fa-long-arrow-alt-right{
    line-height: 24px;
  }
}
.ss-pickuptime{
  color: #535c66;
  font-size: 15px;
  letter-spacing: .6px;
  line-height: 1;
  margin-bottom: 30px;
  font-weight: 600;
}
.service-details{
  padding-bottom: 20px;
}
.sd-category{
  margin-bottom: 10px;

  .sd-c-label{
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 5px;
  }
}
.sd-c-services{
  white-space: nowrap;
  align-items: stretch;
  overflow-x: auto;
  display: flex;
  width: 516px;
  scrollbar-color: #333 #eee;

  .sd-c-box{
    border: 1px solid #abb2b8;
    border-radius: 6px;
    padding: 20px 15px;
    background: #fff;
    width: 250px;
    margin: 0 10px 10px 0;
    text-align: left;
    flex-shrink: 0;
    transition: all .15s ease;

    &.more-info{
      width: 400px
    }
    &.sd-active{
      background: #fffaf0;
    }
  }
  .sd-c-price{
    text-align: right;
    font-size: 25px;
    font-weight: 600;
  }
  img{
    height: 75px;
    margin: 0 auto;
    display: block;
  }
  .sd-c-name{
    font-size: 16px;
    font-weight: 600;
    text-align: left;
    letter-spacing: .6px;
  }
  .sd-c-capacity{
    gap: 20px;
    color: #5E6E7F;
    font-size: 14px;
    margin-bottom: 20px;
    line-height: 1;

    i{
      margin-right: 5px;
    }
  }
  .more-info-cta{
    color: #ECAE20;
    margin: 5px 0 15px;
    display: inline-block;
    line-height: 1;
    font-size: 13px;
    font-weight: 600;
    letter-spacing: .7px;
    cursor: pointer;
  }
  .lr-btn{
    border-radius: 20px;

    &.active{
      background:#5E6E7F;
      cursor: default;
    }
  }
  .is-lyft{
    img {
      height: 130px;
    }
    .sd-c-capacity, .more-info-cta{
      display: none
    }
  }
}
.more-info-box{
  text-align: left;
  overflow: hidden;
  span{
    font-size: 14px;
    line-height: 1.4;
    letter-spacing: .4px;
    display: block;
    color: #777;
    white-space: break-spaces;
  }
  .mi-adv{
    margin-top: 5px;
    b{
      display: block;
    }
  }
  .more-info-cta{
    margin: 15px 0 20px;
  }
}

.slide-left-enter-active {
  transition: all 250ms ease;
 }
.slide-left-leave-active {
  transition: all 300ms ease-out;
}
.slide-left-enter, .slide-left-leave-to{
  transform: translateX(60px);
  opacity: 0;
}

.slide-down-enter-active,
.slide-down-leave-active{
  transition: all 150ms ease;
}
.slide-down-enter, .slide-down-leave-to{
  height: 0;
  opacity: 0;
}
</style>


// WEBPACK FOOTER //
// ServiceSelect.vue?1b99075e